export enum SkeletonShape {
  circle = 'circle',
  square = 'square',
  bar = 'bar'
}
